import { render, staticRenderFns } from "./OtherAvailableSlots.vue?vue&type=template&id=fd6870a0&scoped=true"
import script from "./OtherAvailableSlots.vue?vue&type=script&lang=js"
export * from "./OtherAvailableSlots.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd6870a0",
  null
  
)

export default component.exports